<ng-select
    [ngModel]="value"
    (ngModelChange)="valueChange.emit($event)"
    [items]="options"
    [clearable]="false"
    [searchable]="false"
    appendTo="body"
    class="no-global-contextual-menu-close">
</ng-select>
